export function isImmediateConsultation(schedule) {
  return schedule?.slot_id == null;
}

export function canStartImmediateConsultation(doctor) {
  return doctor?.available_for_immediate_consultation === true;
}

export const DOCTOR_IN_CONSULTATION_MESSAGE =
  "Em consulta no momento. Agende um horário abaixo.";

export function isDoctorInConsultation(doctor) {
  return (
    doctor?.is_online === true &&
    doctor?.available_for_immediate_consultation === false
  );
}

export const IMMEDIATE_CONSULTATION_UNAVAILABLE_MESSAGE =
  "Profissional de saúde indisponível para consulta imediata. Escolha um horário na agenda ou tente novamente em instantes.";

export function getAppointmentErrorMessage(error) {
  const doctorMessage = error?.response?.data?.errors?.doctor_id?.[0];

  if (error?.response?.status === 422 && doctorMessage) {
    return {
      title: "Consulta imediata indisponível",
      text: doctorMessage
    };
  }

  return {
    title: "Erro ao processar a transação",
    text: "Entre em contato com a sua operadora de cartão!"
  };
}

export function showImmediateConsultationUnavailableAlert() {
  return swal.fire({
    icon: "warning",
    title: "Consulta imediata indisponível",
    text: IMMEDIATE_CONSULTATION_UNAVAILABLE_MESSAGE
  });
}
